export const NO_EFFECTIVE_VISIT_TAB_VALUES = {
  VISIT: 'visit'
}

export const NO_EFFECTIVE_VISIT_STATUS_UI_MAP = {
  received: { label: 'RECIBIDO', className: 'received-style' },
  sent: { label: 'ENVIADO', className: 'sent-style' },
  dispatched: { label: 'DESPACHADO', className: 'dispatched-style' },
  invoiced: { label: 'FACTURADO', className: 'billed-style' },
  billed: { label: 'FACTURADO', className: 'billed-style' }
}

export const NO_EFFECTIVE_VISIT_HEADER_CONFIG = {
  titleKey: 'client_name',
  cards: [
    {
      icon: 'barcode_scanner',
      label: 'Código:',
      valueKey: 'client_db_ref'
    },
    {
      icon: 'account_box',
      label: 'Vendedor:',
      valueKey: 'salesman_name',
      filled: true
    },
    {
      icon: 'event',
      label: 'Fecha de creación:',
      valueKey: 'created_date',
      format: 'date'
    }
  ]
}

export const buildNoEffectiveVisitTabs = () => [
  {
    value: NO_EFFECTIVE_VISIT_TAB_VALUES.VISIT,
    label: 'Visita no efectiva',
    icon: 'event_busy',
    iconSize: 20,
    filled: true
  }
]
